import React from 'react';
import { Page, BText } from '../../../components';

export const MySettingSecurity = () => {
  return (
    <Page title={'Security'}>
      <BText>Content</BText>
    </Page>
  );
};
